import reducer from './reducers';

import * as operations from './operations';
import * as selectors from './selectors';

export { operations, selectors };

export default reducer;
